import { PRODUCT_FAMILY_ALL } from '../../constants/productFamily';
import * as actionType from './actionTypes';

const initialState = {
  selectedProduct: PRODUCT_FAMILY_ALL,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.SET_SELECTED_PRODUCT:
      return { ...state, selectedProduct: action.payload };
    case actionType.RESET_SELECTED_PRODUCT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
